// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.rule-summary[data-v-f818d4c8] {\n  margin-bottom: 12px;\n  background: #f5f7fa;\n  border-radius: 8px;\n}\n.summary-item[data-v-f818d4c8] {\n  padding: 8px;\n  line-height: 20px;\n}\n.summary-label[data-v-f818d4c8] {\n  color: #909399;\n}\n.summary-value[data-v-f818d4c8] {\n  color: #303133;\n}\n", ""]);
// Exports
module.exports = exports;
